import { takeLatest } from 'redux-saga/effects';
import {	
    getFaqListSuccess, 
    getFaqListFail,
} from './faqState';

import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/support/faqs');
const redirectData = { route: '/console/faqs', mode: 'list', recordId: 0 };
const modelName = 'Faq';
const modelId = 'faq_id';

function* getFaqList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getFaqListSuccess,
		getFaqListFail, 
		null, null, LOADING_MSG
	);
}

function* faqSaga() {
	yield takeLatest('faq/getFaqList', getFaqList);

}

export default faqSaga;
